// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".marked-left[data-v-4ebc5115]{position:relative}.marked-left[data-v-4ebc5115]:before{background-color:#00a5ef;border-radius:2px;content:\"\";height:100%;left:0;position:absolute;top:0;width:8px}.size[data-v-4ebc5115]{height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
